import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { enabled: Boolean }

  connect() {
    if (!this.enabledValue) return this.showContent()

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const skipped = localStorage.getItem('rc_book_intro_done') || document.cookie.includes('skip_book_intro=1')

    if (prefersReduced || skipped) return this.showContent()

    this.animateBook()
  }

  animateBook() {
    const cover = this.element.querySelector('.cover.front')
    const page = this.element.querySelector('.page')
    const hero = this.element.querySelector('.hero-content')

    // Cover anticipation then open
    cover.animate([
      { transform: 'rotateY(0deg)', boxShadow: '0 15px 30px rgba(0,0,0,0.2)' },
      { transform: 'rotateY(8deg)', boxShadow: '0 20px 40px rgba(0,0,0,0.25)', offset: 0.1 },
      { transform: 'rotateY(0deg)', boxShadow: '0 15px 30px rgba(0,0,0,0.2)', offset: 0.2 },
      { transform: 'rotateY(-160deg)', boxShadow: '0 5px 10px rgba(0,0,0,0.1)' }
    ], {
      duration: 2000,
      easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
      fill: 'forwards'
    })

    // Page flip after cover opens
    setTimeout(() => {
      page.animate([
        { transform: 'rotateY(180deg)' },
        { transform: 'rotateY(0deg)' }
      ], {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      })
    }, 1600)

    // Reveal hero content
    setTimeout(() => {
      hero.classList.remove('opacity-0', 'translate-y-4')
      localStorage.setItem('rc_book_intro_done', '1')
    }, 1700)
  }

  showContent() {
    this.element.querySelector('.hero-content').classList.remove('opacity-0', 'translate-y-4')
  }

  skip() {
    localStorage.setItem('rc_book_intro_done', '1')
    document.cookie = 'skip_book_intro=1; path=/'
    this.showContent()
  }
}
